import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BackButtonService } from './data/fireservices/back-button.service';
import { VersionService } from './data/services/version.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(private platform: Platform,
              public cerraApp: BackButtonService,
              private version: VersionService
              ) {
                this.version.iniciar();
                this.initializeApp()
     }

  initializeApp(){
    this.platform.ready().then(() =>{
      this.cerraApp.init();
    })
  }

  
}
